import { useAppSelector } from 'store/hooks';
import { selectRecorderLogoVisibility } from 'features/recorder/recorderSlice';
import { selectCurrentSystemRole } from 'features/application/selectors';
import RecorderTopBar from 'features/topbar/components/RecorderTopBar';
import RoomTopBar from 'features/topbar/components/RoomTopBar';
import { SystemSessionGuard } from 'components/SystemSessionGuard';
import { selectTopbarVisibility } from 'features/topbar/topbarSlice';
import { selectRestreamerLogoVisibility } from 'features/restreamer/restreamerSlice';

const TopBar = () => {
  const systemRole = useAppSelector(selectCurrentSystemRole);
  const recordingLogoVisible = useAppSelector(selectRecorderLogoVisibility);
  const restreamerLogoVisible = useAppSelector(selectRestreamerLogoVisibility);

  const topbarVisible = useAppSelector(selectTopbarVisibility);

  const showSystemTopbar =
    (systemRole === 'recorder' && recordingLogoVisible) ||
    (systemRole === 'restreamer' && restreamerLogoVisible);

  if (showSystemTopbar) {
    return <RecorderTopBar />;
  }

  if (!topbarVisible) {
    return null;
  }

  return (
    <SystemSessionGuard>
      <RoomTopBar />
    </SystemSessionGuard>
  );
};

export default TopBar;
